import { NotifyHelper } from 'classes/helpers/notify.helper';
import { useActiveListId } from 'hooks/useActiveListId';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { paths } from 'routes/paths';
import useListLibraryStore from 'stores/use-list-library-store';

/**
 * The URL can reference a list the user cannot access (e.g. a shared link, or a
 * list that was reassigned away). Since activeList is derived, an id in the URL
 * with no match in the loaded lists means "no access": warn and redirect home.
 */
const useEnforceListAccess = () => {
  const navigate = useNavigate();

  const loading = useListLibraryStore((s) => s.loading);
  const lists = useListLibraryStore((s) => s.lists);

  // get the list id from the URL
  const activeListId = useActiveListId();

  useEffect(() => {
    if (loading || lists.length === 0) {
      // still loading
      return;
    }

    if (!activeListId) {
      // no list id in the URL
      return;
    }

    if (lists.findIndex((l) => l._id === activeListId) !== -1) {
      // active list is accessible
      return;
    }

    NotifyHelper.warning({
      message_md: 'You do not have access to this pitch list.',
    });
    navigate(paths.home);
  }, [loading, activeListId, lists]);
};

export default useEnforceListAccess;
